import React from 'react';
import Button from '../../../../components/Button/Button';
import {
  useDeleteTabsFieldMutation,
  useDeleteTabsTableMutation,
} from '@/services/fieldApi/FieldApi';
import { useToast } from '../../../../components/Toast/ToastContext';
import { useParams } from 'react-router-dom';

interface IDeleteFieldProps {
  closePopUp: () => void;
  FieldData: any;
  sectionId: string;
  FieldTabsId?: string;
  tabId?: string;
}

const DeleteTabsField: React.FC<IDeleteFieldProps> = ({
  closePopUp,
  FieldData,
  sectionId,
  FieldTabsId,
  tabId,
}) => {
  const { addToast } = useToast();
  const { id } = useParams();
  const [deleteField] = useDeleteTabsFieldMutation();
  const [deleteTable] = useDeleteTabsTableMutation();

  const handleDelete = async () => {
    try {
      let response;
      if (FieldData.field_type === 'table') {
        response = await deleteTable({
          factSheetId: id ?? '',
          sectionId: sectionId,
          tabFieldId: FieldTabsId,
          tabId: tabId,
          tableId: FieldData.field_id,
        }).unwrap();
      } else {
        response = await deleteField({
          factSheetId: id ?? '',
          sectionId: sectionId,
          tabFieldId: FieldTabsId,
          tabId: tabId,
          fieldId: FieldData.field_id,
        }).unwrap();
      }

      if (response) {
        addToast('Field Deleted', 'Field is Deleted successfully.', 'success');
      }
      closePopUp();
    } catch (error) {
      addToast('Section Deletion Failed', 'Field to delete section. Please try again. ', 'error');
    }
  };
  return (
    <div>
      <p className="text-md text-ds-gray-500">
        Are you sure you want to delete this field? This will permanently remove it from the form,
        and any collected data will be lost. This action cannot be undone.
      </p>

      <div className="mt-4 flex justify-end gap-2">
        <Button onClick={closePopUp}>Cancel</Button>
        <Button color="error" type="button" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteTabsField;
